<template>
    <v-layout>
        <v-data-table
            pt-4
            v-if="historyLength > 0"
            :headers="tableHeaders"
            :items="tableItems"
            hide-actions
            no-data-text="Нет данных"
            no-results-text="Ничего не найдено"
            class="kbm-table"
        >
            <template v-slot:items="result">
                <tr class="text-align-center">
                    <td>{{ result.item.date }}</td>
                    <td>{{ result.item.kbm }}</td>
                    <td>{{ result.item.class }}</td>
                    <td>{{ result.item.losses }}</td>
                    <td>
                        <a class="policy" :href="result.item.link" target="_blank">Скачать</a>
                    </td>
                </tr>
            </template>
            <template v-slot:headers="result">
                <tr>
                    <th
                        v-for="header in result.headers"
                        :key="header.text"
                        :class="'column'"
                    >
                        {{ header.text }}
                        <img v-if="header.value === 'link'" class="tip-icon" src="/svg/q.svg" alt=""
                                data-tippy-animateFill="false"
                                data-tippy-animation="scale"
                                data-tippy-content="Если срок хранения файла истёк - просто проверьте КБМ ещё раз!"
                        />
                    </th>
                </tr>
            </template>
        </v-data-table>
        <v-flex v-if="historyLength === 0" pt-4>
            <h4>Информация не найдена</h4>
        </v-flex>
    </v-layout>
</template>
<script>
    export default {
        name: 'KbmResultList',
        props: ['result'],
        data:() => ({
            history: [],
            tableHeaders: [
                {
                    text: 'Дата',
                    align: 'center',
                    sortable: false,
                    value: 'date'
                },
                {
                    text: 'КБМ',
                    align: 'center',
                    sortable: false,
                    value: 'kbm'
                },
                {
                    text: 'Класс КБМ',
                    align: 'center',
                    sortable: false,
                    value: 'class'
                },
                {
                    text: 'Страховые случаи',
                    align: 'center',
                    sortable: false,
                    value: 'losses'
                },
                {
                    text: 'Файл доступен 5 мин.',
                    align: 'center',
                    sortable: false,
                    value: 'link'
                },
            ],
            tableItems: [],
        }),
        computed: {
            historyLength() {
                return this.result ? this.result.length : 0
            }
        },
        mounted: function() {
            if (this.result.length) {
                this.prepareHistory(this.result)
            }
        },
        methods: {
            prepareHistory(history) {
                let items = []
                history.forEach(item => {
                    let losses = 0
                    if (Array.isArray(item.lossCRTTypeList) && item.lossCRTTypeList.length) {
                        item.lossCRTTypeList.forEach( loss => {
                            if (loss.policyNumberKey) {
                                losses++
                            }
                        })
                    }
                    items.push({
                        date: item.datekbm,
                        kbm: item.kbmValue,
                        class: item.kbmClass,
                        losses: losses,
                        link: item.download
                    })
                })
                this.tableItems = items
            },
        }
    }
</script>
<style scoped>
    .kbm-table {
        width: 100%;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/services/ServicesKbmResult.vue